import React from 'react'
import './buttonList.css'

function ButtonList({setIsLoggedIn, setVisiblePage}) {

    function logout(){
        localStorage.removeItem('authToken');
        setIsLoggedIn(false)
        // window.location.href = './'
    }

    return (

        <section className="buttons-section">
            <p>What's on your mind?</p>
            <div className='button-cards'>
                <div onClick={()=>setVisiblePage('dataEntry')} className='button-card'>
                    <span>Data Entry</span>
                </div>
                <div onClick={()=>setVisiblePage('dataTable')} className='button-card'>
                    <span>Display Data</span>
                </div>
                <div onClick={()=>setVisiblePage('filterPage')} className='button-card'>
                    <span>Print Receipt</span>
                </div>
                <div onClick={()=>setVisiblePage('frkDataEntry')} className='button-card'>
                    <span>FRK Data Entry</span>
                </div>
                <div onClick={()=>setVisiblePage('frkDataDisplay')} className='button-card'>
                    <span>FRK Data Display</span>
                </div>
                <div onClick={()=>setVisiblePage('billOfSupplyEntry')} className='button-card'>
                    <span>BOS Entry</span>
                </div>
                <div onClick={logout} className='button-card'>
                    <span>Logout</span>
                </div>
            </div>
        </section>
    )
}

export default ButtonList